
import { defineComponent, ref, getCurrentInstance, computed } from "vue";
import Subtitle from "~/components/Common/Subtitle.vue";
import UserColumnModel from "~/models/UserColumnModel";
import UserColumnsRepository from "~/repositories/UserColumnsRepository";
import InfiniteLoadingContent from "~/components/Common/InfiniteLoadingContent.vue";
import ColumnModal from "~/components/Readers/ColumnModal.vue";

export default defineComponent({
  name: "UserColumns",
  components: {
    ColumnModal,
    Subtitle,
    InfiniteLoadingContent
  },
  props: {
    userAccountId: {
      type: Number,
      required: true
    },
    enableInfiniteLoad: {
      type: Boolean,
      default: true
    },
    isCurrentUserPage: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const vm = getCurrentInstance();

    const columns = ref<Array<UserColumnModel>>([]);
    const loading = ref<boolean>(true);
    const onLoading = async ($state) => {
      try {
        const repo = new UserColumnsRepository();
        const params = {
          q: {
            user_account_id_eq: props.userAccountId
          },
          limit: 4,
          offset: columns.value.length
        };
        const results = await repo.index(params);
        columns.value = columns.value.concat(results);
        if (props.enableInfiniteLoad && results.length > 0) {
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (e) {
        alert("コラムの取得に失敗しました。時間を置いてから再度お試しください。");
        $state.error();
      } finally {
        loading.value = false;
      }
    };

    const showSendDate = computed(() => {
      // HACK: vmの$dayjsがtsのタイプ定義されていないのでignoreで対応
      // @ts-ignore
      return date => vm.proxy.$dayjs(date).format("YYYY年M月D日");
    });

    const imageUrl = (column) => {
      return column.image ? column.image : "/static/image/corporation/corporation_column_sample.svg";
    };

    const selectedColumn = ref<UserColumnModel>({});
    const isModalVisible = ref(false);
    const convertToModalObject = (column) => {
      // MEMO: ColumnModalのObjectがスネークケースなので合わせる
      return {
        title: column.title,
        sub_title: column.subTitle,
        media_date: column.mediaDate,
        content: column.content,
        image: column.image
      };
    };
    const select = (event, column) => {
      event.preventDefault();
      selectedColumn.value = convertToModalObject(column);
      isModalVisible.value = true;
    };
    const close = () => {
      isModalVisible.value = false;
    };

    return {
      columns,
      onLoading,
      showSendDate,
      imageUrl,
      select,
      isModalVisible,
      selectedColumn,
      loading,
      close
    };
  }
});
